import axios from 'axios';
import { getRequestConfig, replaceUrlPlaceholder, REQUEST_TYPES } from '../request';
import API_END_POINTS from '../endpoints';

/**
 * Initial load driver user by token to verify token
 *
 * @param {string} id
 * @param {string} token
 * @param {function} onSuccess
 * @param {function} onError
 */
export const apiGetDeliveriesUser = function (token, id, onSuccess, onError) {
  const url = replaceUrlPlaceholder(API_END_POINTS.GET_DRIVER, 'id', id);
  const config = getRequestConfig(REQUEST_TYPES.GET, url);

  config.headers = {
    authorization: 'Bearer ' + token,
  };
  axios(config)
    .then((response) => {
      onSuccess && onSuccess(response.data);
    })
    .catch((error) => {
      onError && onError(error);
    });
};
